<template>
  <div :class="value ? 'background-color--' + value : ''">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FondoColor',
  props: {
    value: { type: String, required: false, default: '' },
  },
}
</script>
